import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.sort";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _name$mixins$data$com;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 商品列表
 * @author shendeying
 */
import BackEventMixins from '~/mixins/back-event-mixins';
import config from '$config';
import api from 'api/goods';
import CommonUtils from 'utils/CommonUtils';
import { mapMutations, mapGetters } from 'vuex';
import { GET_SCREEN } from '$getters';
import { SET_NAV_CALLBACK } from '$mutations';
export default (_name$mixins$data$com = {
  name: 'page-goods-list',
  mixins: [BackEventMixins],
  data: function data() {
    return {
      templateInfo: null,
      showList: false,
      selectList: [],
      pageConfig: {
        page: 0,
        size: 10,
        goodsTemplateId: '',
        goodsSearchTemplateIdList: [],
        sort: [],
        keyword: null,
        explosion: null,
        recommend: null
      },
      searchfilter: [],
      list: [],
      fetchFun: api.selectAppGoodsList,
      sortList: [{
        name: 'inventory',
        // 库存:name=inventory,价格 name=singlemachine
        label: '数量排序' // sortCol: 0 // 1降序0升序

      }, {
        name: 'singlemachine',
        label: '价格排序' // sortCol: 0 // 1降序0升序

      }],
      showfilter: false,
      isFromCategory: false // 是否从分类页跳转至此

    };
  },
  computed: _objectSpread({
    fileURL: function fileURL() {
      return config.fileURL;
    }
  }, mapGetters({
    screen: GET_SCREEN
  })),
  watch: {
    '$route.path': function $routePath(val, old) {
      if (old === '/goodsDetail' && this.list.length === 0) {
        this.fetchFun();
      }
    },
    '$route.query': {
      handler: function handler(val) {
        var that = this;

        if (val) {
          that.cgbp = val;
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    var that = this;
  },
  methods: _objectSpread(_objectSpread({
    getStock: CommonUtils.getStock,
    formatDate: CommonUtils.format
  }, mapMutations([SET_NAV_CALLBACK])), {}, {
    flushList: function flushList() {
      this.$refs.list.flushList(); // console.log('=============', this.$refs.list)
    },
    fetchData: function fetchData() {
      this.$refs.list.fetchData();
    },
    // 排序变更重新请求列表
    sortChange: function sortChange(params) {
      if (params) {
        this.$set(this.pageConfig.sort, 0, params);
        this.flushList();
      }
    },
    // 点击排序默认按钮时触发
    sortReset: function sortReset() {
      this.pageConfig.sort = [];
      this.flushList();
    },
    // 过滤显示商品属性
    filterisAppMain: function filterisAppMain(list, order) {
      function filterIsMain(item) {
        return item.isAppMain === order && item.detailsValue;
      }

      return list.filter(filterIsMain);
    },
    // 过滤某属性
    filterrisproperty: function filterrisproperty(list, key) {
      function filterIsMain(item) {
        return item.detailsFieldName === key && item.detailsValue;
      } // var arr= list.filter(filterIsMain)
      // console.log(arr)


      return list.filter(filterIsMain);
    },
    // 点击右上角筛选按钮
    filterFun: function filterFun() {
      this.showfilter = true;
    },
    // 确认提交并关闭筛选内容
    submitFilter: function submitFilter(filter) {
      var _this = this;

      this.pageConfig.goodsSearchTemplateIdList = [];

      if (filter && filter.length > 0) {
        filter.forEach(function (item) {
          _this.pageConfig.goodsSearchTemplateIdList.push(item.id);
        });
      }

      this.selectList.forEach(function (item) {
        if (_this.pageConfig.goodsSearchTemplateIdList.indexOf(item.id) == -1) {
          _this.pageConfig.goodsSearchTemplateIdList.push(item.id);
        }
      });
      this.flushList();
      var vm = this;
      var param = vm.$route.params != null && Object.keys(vm.$route.params).length > 0 ? vm.$route.params : vm.$route.query;

      if (param.goodsSearchTemplateIdList) {
        vm.searchfilter = [];

        if (param.goodsSearchTemplateIdList instanceof Array) {
          param.goodsSearchTemplateIdList.forEach(function (element) {
            vm.searchfilter.push(element);
          });
        } else {
          vm.searchfilter.push(param.goodsSearchTemplateIdList);
        }
      }

      this.showfilter = false;
    },
    // 查看商品详情
    view: function view(id) {
      // this.$ref.list.scrollTop
      var scrollTop = window.document.getElementById('list').scrollTop; // console.log('scrollTop: ', window.document.getElementById('list').scrollTop)
      // console.log('this.$refs.list.scrollTop: ', this.$refs.list.scrollTop)

      this.$router.push({
        path: 'goodsDetail',
        query: {
          goodsId: id,
          scrollTop: scrollTop
        }
      });
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // vm.$nextTick(() => {
      //   if (vm.$refs.list) {
      //     console.log('vm.$refs.list: ', vm.$refs.list)
      //     window.document.getElementById('list').scrollTop = 180
      //   }
      // })
      vm.isFromCategory = false;

      if (from && from.path === '/category') {
        vm.isFromCategory = true;
      }

      if (vm.SET_NAV_CALLBACK) {
        if (vm.backFun) {
          vm.SET_NAV_CALLBACK({
            backFun: vm.backFun
          });
        }

        if (vm.filterFun) {
          vm.SET_NAV_CALLBACK({
            filterFun: vm.filterFun
          });
        }
      }

      if (from.path === '/goodsDetail') {
        vm.$nextTick(function () {
          // console.log('from: ', from)
          // console.log('vm.$refs.list: ', vm.$refs.list)
          if (vm.showList) {
            // console.log('scrollTop: ', window.document.getElementById('list').scrollTop)
            // window.document.getElementById('list').scrollTop = 180
            window.document.getElementById('list').scrollTop = from.query.scrollTop;
          }
        });
      }

      if (from.path !== '/goodsDetail') {
        vm.pageConfig = {
          page: 0,
          size: 10,
          goodsTemplateId: '',
          goodsSearchTemplateIdList: [],
          sort: [],
          keyword: null,
          explosion: null,
          recommend: null
        };

        if (vm.$route.query || vm.$route.params) {
          vm.showList = false;
          var param = vm.$route.params != null && Object.keys(vm.$route.params).length > 0 ? vm.$route.params : vm.$route.query; // 是否为爆款列表

          if (param.explosion) {
            vm.pageConfig.explosion = param.explosion;
          } // 是否为推荐列表


          if (param.recommend) {
            vm.pageConfig.recommend = param.recommend;
          } // 商品大类绑定


          if (param.templateId) {
            vm.pageConfig.goodsTemplateId = param.templateId; // 获取商品大类相关信息（包括站位图等）
            // let postData = {
            //   templateId: param.templateId
            // }
            // api.selectGoodsTemplateInfo(postData).then(res => {
            //   vm.templateInfo = res.data
            // })
          } // 关键字绑定


          if (param.keyword) {
            vm.pageConfig.keyword = param.keyword;
          } //获取子组件传的数字转化类型
          // console.log(param.cgTemplateId);
          // vm.searchfilterid=param.cgTemplateId.map(Number)
          // param.cgTemplateId.forEach(item => {
          //   vm.pageConfig.goodsSearchTemplateIdList.push(item)
          //   vm.searchfilter.push(parseInt(item))
          // })


          console.log("ddddd", vm.$route.query, param);

          if (param.goodsSearchTemplateIdList) {
            vm.searchfilter = [];

            if (param.goodsSearchTemplateIdList instanceof Array) {
              param.goodsSearchTemplateIdList.forEach(function (element) {
                vm.pageConfig.goodsSearchTemplateIdList.push(parseInt(element));
                vm.searchfilter.push(parseInt(element));
              });
            } else {
              vm.pageConfig.goodsSearchTemplateIdList.push(parseInt(param.goodsSearchTemplateIdList));
              vm.searchfilter.push(parseInt(param.goodsSearchTemplateIdList));
            }
          } // if (param.cgTemplateId) {
          //   vm.pageConfig.goodsSearchTemplateIdList.push(param.cgTemplateId)
          // }
          // 商品属性绑定


          if (param.selectList) {
            vm.selectList = param.selectList;
            vm.selectList.forEach(function (item) {
              vm.pageConfig.goodsSearchTemplateIdList.push(item.templateId);
            });
          }

          vm.$nextTick(function () {
            vm.showList = true;
          });
        }
      }
    });
  }
}, _defineProperty(_name$mixins$data$com, "mounted", function mounted() {// this.SET_NAV_CALLBACK({
  //   backFun: this.backFun,
  //   filterFun: this.filterFun
  // })
}), _defineProperty(_name$mixins$data$com, "components", {}), _name$mixins$data$com);